import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import WatchLaterOutlinedIcon from "@mui/icons-material/WatchLaterOutlined";
import { NotificationItemCountdown } from "../../NotificationItem.styled";
let interval;
const Countdown = React.memo(({ startDate }) => {
    const [time, setTime] = useState("--:--");
    useEffect(() => {
        interval = setInterval(() => {
            const eventStartDate = new Date(startDate).getTime();
            const distance = eventStartDate - Date.now();
            const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)).toString();
            const seconds = Math.floor((distance % (1000 * 60)) / 1000);
            setTime(`${minutes.padStart(2, "0")}:${seconds}`);
            if (distance < 0) {
                setTime("00:00");
                clearInterval(interval);
            }
        }, 1000);
        return () => clearInterval(interval);
    }, []);
    return (_jsxs(NotificationItemCountdown, { children: [_jsx(WatchLaterOutlinedIcon, { fontSize: "inherit" }), time] }));
});
export { Countdown };
//# sourceMappingURL=Countdown.js.map